import React from 'react';
import { i18n } from 'utils/i18n';
import { MODAL, MODAL_THEMES } from 'constants';
import Modal from 'components/Modal';
import UnavailableLocationModalContent from 'components/UnavailableLocationModalContent';

const UnavailableLocationModal = ({
  showReturnLocation,
  updateReservationFlowLocation,
  currentLocation,
  exchangeType,
  one_way_rental,
}) => (
  <Modal
    modalKey={MODAL.INVALID_DATE_FOR_RES_FLOW}
    theme={MODAL_THEMES.BLUE}
    header={i18n('unavailable_location_modal_main_header')}
  >
    <UnavailableLocationModalContent
      showReturnLocation={showReturnLocation}
      updateReservationFlowLocation={updateReservationFlowLocation}
      locationName={currentLocation && currentLocation.name}
      locationIdSelectedInUnavailableLocationModal={currentLocation && currentLocation.id}
      location={currentLocation}
      exchangeType={exchangeType}
      one_way_rental={one_way_rental}
      describedByID={`${MODAL.INVALID_DATE_FOR_RES_FLOW}_desc`}
    />
  </Modal>
);

export default UnavailableLocationModal;
